import * as React from "react";

const fields = (t) => ({
    config: {columns: 1},
    fields: [
        {
            name: "machineType",
            label: t ? t("common.machine_type") : "Typ maszyny",
            column: 1,
            type: "enum",
            enumType: "enums/machineType",
            mandatory: true
        },
        {
            name: "model",
            label: t ? t("common.model") : "Model",
            mandatory: true,
            column: 1,
        }
    ]


});

export default fields;